@if(isPopoverVisible()) {
    <div
    #popoverBody
    class="popover-body rounded-md absolute top-10 z-50 absolute right-4 mt-2 rounded-xl border border-gray-200 bg-white shadow-theme-lg mt-[17px] flex w-[260px] flex-col p-3"
    >
        <ng-content />
    </div>
}
